import React, {forwardRef, useImperativeHandle} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {FormControl, FormHelperText, Typography, Checkbox, FormControlLabel} from '@material-ui/core';
import Grid from "@material-ui/core/Grid";
import LabelValue from "../../../shared/labelvalue/LabelValue.js";
import useFormularioInscricao from './useFormularioInscricao';
import * as Yup from "yup";

const useStyles = makeStyles(theme => ({
    tituloTermo: {
        fontWeight: 'bold',
        marginBottom: theme.spacing(1)
    },
    root: {
        marginBottom: theme.spacing(2)
    },
    termBox: {
        backgroundColor: theme.palette.grey[50],
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 4,
        padding: theme.spacing(3),
        height: 250,
        overflowY: 'scroll',
        marginBottom: theme.spacing(3)
    },
    title: {
        color: theme.palette.primary.main,
        fontWeight: 'bold',
        marginBottom: theme.spacing(1)
    },
    paragraph: {
        fontSize: '0.9rem',
        lineHeight: '1.5',
        marginBottom: theme.spacing(2)
    }
}));

export const schemaFinalizar = Yup.object().shape({
    aceitarTermos: Yup.boolean().oneOf([true], 'Você precisa aceitar os termos para concluir a inscrição')
});

const FormFinalizar = forwardRef((props, ref) => {
    const classes = useStyles();
    const {data, onUpdate} = props;

    const formEtapa = useFormularioInscricao({
        valoresIniciais: {...data},
        reinicializar: true,
        schema: schemaFinalizar
    });

    useImperativeHandle(ref, () => ({
        formulario: formEtapa.api
    }));

    return (
        <form className={classes.root} noValidate autoComplete="off">
            <div className={classes.termBox}>
                <Typography variant="subtitle1" className={classes.tituloTermo}>
                    DECLARAÇÃO DE RESPONSABILIDADE E VERACIDADE
                </Typography>
                <Typography variant="body2" className={classes.paragraph}>
                    1. Declaro, sob as penas da lei, que todas as informações prestadas neste formulário de inscrição socioeconômica são expressão da verdade e que os documentos digitalizados e anexados são cópias fiéis dos originais.
                </Typography>
                <Typography variant="body2" className={classes.paragraph}>
                    2. Estou ciente de que a omissão de dados ou a prestação de informações falsas resultará na desclassificação imediata do processo de seleção de benefícios de assistência estudantil, além de acarretar a cobrança retroativa de quaisquer valores concedidos indevidamente e a aplicação das sanções penais cabíveis (Art. 299 do Código Penal - Falsidade Ideológica).
                </Typography>
                <Typography variant="body2" className={classes.paragraph}>
                    3. Autorizo a Comissão de Seleção e Acompanhamento de Benefícios a realizar visitas domiciliares, solicitar esclarecimentos adicionais e verificar a veracidade das informações apresentadas junto a órgãos públicos e privados (receita federal, cartórios, empregadores, etc.).
                </Typography>
                <Typography variant="body2" className={classes.paragraph}>
                    4. Comprometo-me a informar imediatamente qualquer alteração na situação socioeconômica familiar (mudança de renda, de moradia ou de composição do grupo familiar) que ocorra no decorrer do ano letivo.
                </Typography>
            </div>

            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormControl error={formEtapa.tocados.aceitarTermos && !!formEtapa.erros.aceitarTermos}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="aceitarTermos"
                                    checked={formEtapa.valores.aceitarTermos}
                                    onChange={formEtapa.aoMudar}
                                    color="primary"
                                />
                            }
                            label="Li e concordo com a declaração de veracidade das informações e os termos acima descritos. *"
                        />
                        {formEtapa.tocados.aceitarTermos && formEtapa.erros.aceitarTermos && (
                            <FormHelperText>{formEtapa.erros.aceitarTermos}</FormHelperText>
                        )}
                    </FormControl>
                </Grid>
            </Grid>
        </form>
    );
});

FormFinalizar.displayName = 'FormFinalizar';
export default FormFinalizar;
